<a
	title="Messagerie"
	class="btn nav-link"
	routerLink="/messagerie"
	(click)="resetNotificationNumber()"
>
	<i class="bi bi-envelope topbar-blue-button" aria-hidden="true"></i>
	<span class="badge rounded-pill mt-1">{{
		notificationNumber > 0 ? notificationNumber : ''
	}}</span>
</a>
